import { createContext } from 'react';

export const EventContext = createContext({
  actualEvent: null,
  lat: null,
  lng: null,
  addEvent: () => {},
});

